import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { UserDto, UserService } from '@api-client';
import { AuthTokenService } from '@client-libs';

@Injectable({ providedIn: 'root' })
export class UserStore {
  private readonly userService = inject(UserService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly router = inject(Router);
  private readonly authTokenService = inject(AuthTokenService);

  user = signal<UserDto | undefined>(undefined);
  user$ = toObservable(this.user);

  constructor() {
    const user = this.user();
    if (!user) {
      this.fetch();
    }
  }

  fetch() {
    if (isPlatformServer(this.platformId)) return;

    this.userService.userControllerGetMe().subscribe({
      next: data => {
        this.user.set(data);
      },
      // 비로그인 상태는 정상 상태이므로 에러 무시 (user는 undefined 유지)
      error: () => void 0,
    });
  }

  setUser(user: UserDto | undefined) {
    this.user.set(user);
  }

  async logout() {
    if (isPlatformServer(this.platformId)) return;

    this.userService.userControllerLogout().subscribe({
      next: () => {
        this.user.set(undefined);
        this.authTokenService.clearTokens();
        this.router.navigateByUrl('/sign-in', {
          replaceUrl: true,
        });
      },
    });
  }

  clearUser() {
    this.user.set(undefined);
  }

  async fetchUser() {
    this.fetch();
  }
}
